/**
 * Util to detect PWA or not in iOS
 */

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export const isIOSPWA = (): boolean => (window.navigator as any)?.standalone === true;

/**
 * Util to detect PWA or not in Android
 */
export const isAndroidPWA = () => window.matchMedia('(display-mode: standalone)').matches;

/**
 * Util to detect PWA or not.
 */
export const isPWA = (): boolean => isAndroidPWA() || isIOSPWA();
